import { CreationToolFrame } from '../types'

type RGBA = {
    r: number
    g: number
    b: number
    a: number
}

const rgba2rgb = (RGBAColor: RGBA): RGBA => {
    const RGB_background: RGBA = {
        r: 0,
        g: 0,
        b: 0,
        a: 255,
    }
    const alpha = RGBAColor.a / 255

    const finalRGB = {
        r: (1 - alpha) * RGB_background.r + alpha * RGBAColor.r,
        g: (1 - alpha) * RGB_background.g + alpha * RGBAColor.g,
        b: (1 - alpha) * RGB_background.b + alpha * RGBAColor.b,
        a: 255,
    }

    return finalRGB
}

const convertTransparencyIntoPixel = (imageData: ImageData): ImageData => {
    const data = imageData.data
    for (let i = 0; i < data.length; i += 4) {
        // check if is an alpha pixel
        if (data[i + 3] > 0 && data[i + 3] < 255) {
            const newPixelColor = rgba2rgb({
                r: data[i],
                g: data[i + 1],
                b: data[i + 2],
                a: data[i + 3],
            })

            data[i] = newPixelColor.r
            data[i + 1] = newPixelColor.g
            data[i + 2] = newPixelColor.b
            data[i + 3] = newPixelColor.a
        }
    }
    return imageData
}

const fixTransparency = (canvas): HTMLCanvasElement => {
    const outputCanvas = document.createElement('canvas')
    const outputContext = outputCanvas.getContext('2d')
    const context = canvas.getContext('2d')

    if (context && outputContext) {
        // scale the output canvas to fit in our min/max output size
        outputCanvas.width = canvas.width
        outputCanvas.height = canvas.height

        // draw scaled canvas
        outputContext.drawImage(canvas, 0, 0, outputCanvas.width, outputCanvas.height)

        // get image data
        const imageData = outputContext.getImageData(0, 0, outputCanvas.width, outputCanvas.height)

        // remove semi-transparent pixels
        outputContext.putImageData(convertTransparencyIntoPixel(imageData), 0, 0)

        return outputCanvas
    }

    return canvas
}

export const getFramesWithoutOpacity = (frames: CreationToolFrame[]): CreationToolFrame[] => {
    return frames.map((frame) => {
        return { ...frame, canvas: fixTransparency(frame.canvas) }
    })
}
